module.exports = __webpack_public_path__ + "static/kumadex-jlpt-n3-25-words-1dbf5c76f28e46a282533df28758d38e.png";